// MobileNavDrawer.tsx
// Internal AppShell chrome. Not exported. Renders the sider content inside
// an AntD Drawer at the mobile breakpoint.

import { Drawer, theme as antTheme } from 'antd';
import type { ReactNode } from 'react';

interface MobileNavDrawerProps {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
}

export function MobileNavDrawer({ open, onClose, children }: MobileNavDrawerProps) {
  const { token } = antTheme.useToken();
  return (
    <Drawer
      aria-label="Navigation menu"
      placement="left"
      width={280}
      open={open}
      onClose={onClose}
      closable={false}
      styles={{
        body: { padding: 0, background: token.colorBgContainer },
        header: { display: 'none' },
        wrapper: { boxShadow: 'none' },
      }}
    >
      {children}
    </Drawer>
  );
}
